module.exports = __webpack_public_path__ + "static/media/eye.32744657.svg";